<template>
	<div class="foot_box">
		<div class="foot_bx">
			<div class="foot_p">
				版权所有：安徽省农业科学院 <a @click="gg_btn">详细阅读版权公告</a> 
				<span>All right reserved. 皖公网安备 34010302000817号</span>
			</div>
			<div class="foot_p">地址：合肥市庐阳区农科南路40号&nbsp;&nbsp;&nbsp;邮编：230001</div>
		</div>
	</div>
</template>

<script>
	export default{
		methods: {
			gg_btn() {
				this.$store.commit('SET_TAB', 'bqgg')
				this.$router.push({
					path: 'copyright'
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.foot_box{
		height: 104px;
		background-color: #22AB67;
		.foot_bx{
			width: 1200px;
			margin: 0 auto;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			font-size: 10px;
			color: #fff;
			.foot_p{
				margin: 9px 0;
			}
			a{
				color: #fff;
				text-decoration: underline;
				margin-right: 10px;
				cursor: pointer;
			}
		}
	}
</style>
